export default __webpack_public_path__ + "static/media/Ballroll_00182.2f5b940f.png";